import jquery from "./jquery-1.11.2.min";

export default window.$ = window.jQuery = jquery;
